import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconMenu } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useCategoriesNavigationContext } from './StoryblokCategoryNavigationProvider'

export const StoryblokCategoryNavigationButton: FC = () => {
  const { handleOpen } = useCategoriesNavigationContext()

  return (
    <Button
      className="w-full gap-1"
      color="secondary"
      onClick={handleOpen}
      size="medium"
    >
      <IconMenu className="size-6" />
      <FormattedMessage id="general.label.categories" />
    </Button>
  )
}
